<script setup>
// import { ref } from 'vue';
import CustomComboBox from "@/components/Custom_DDL_Checkbox.vue";
import SewaPajakTable from "./Tables/SewaPajakTable.vue";
import ArgonInput from "@/components/ArgonInput.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Sewa Pajak</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label text-danger">Block Id</label>
                            <CustomComboBox :list="blockList" v-model="model.sewaPajak.blockid"/>
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Payment Date</label>
                            <input type="date" id="input_date" v-model="model.sewaPajak.dateInv" class="form-control">
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">From</label>
                            <input type="date" id="input_date" v-model="model.sewaPajak.datefrom" class="form-control">
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">To</label>
                            <input type="date" id="input_date" v-model="model.sewaPajak.dateto" class="form-control">
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Payment Type</label>
                            <select class="form-control" v-model="model.sewaPajak.paymenttype" @change="onChangePaymentType">
                                <option value="0">Cash</option>
                                <option value="1">Bank Trasfer</option>
                            </select>
                        </div>
                        <div class="col-md-2" v-show="model.sewaPajak.paymenttype == 1">
                            <label for="example-text-input" class="form-control-label text-danger">Bank</label>
                            <input class="form-control" v-model="model.sewaPajak.bank" id="input_amount" type="text" placeholder="Bank Name" />
                        </div>
                        <div class="col-md-2" v-show="model.sewaPajak.paymenttype == 1">
                            <label for="example-text-input" class="form-control-label text-danger">Account</label>
                            <input class="form-control" v-model="model.sewaPajak.bankacc" id="input_amount" type="text" placeholder="80.00" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label text-danger">Amount</label>
                            <input class="form-control" v-model="model.sewaPajak.amount" id="input_amount" type="number" placeholder="80.00" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <argon-input type="text" id="input_remark" v-model="model.sewaPajak.remark"  placeholder="Remark...." />
                        </div>
                    </div>
                    <!-- <div class="row ">
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Term</label>
                            <input class="form-control" v-model="model.block.term" id="input_term" type="text" placeholder="One Month" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Bank</label>
                            <input class="form-control" v-model="model.block.bank" id="input_bank" type="text" placeholder="Publick Bank" />
                        </div>
                        <div class="col-md-2">
                            <label for="example-text-input" class="form-control-label">Bank Acc</label>
                            <input class="form-control" v-model="model.block.bankacc" id="input_bankacc" type="number" placeholder="99999999999" />
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Name</label>
                            <input class="form-control" v-model="model.block.name" id="input_name" type="text" placeholder="Ang Wei Ze" />
                        </div>
                    </div> -->
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success " @click="addSewaPajak" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <SewaPajakTable :key="componentKey" />
        </div>
    </div>
</div>
</template>


<script>
import axios from 'axios';

export default {
  name:'AddSewaPajak',
  data(){
    return {
        componentKey: 0,
        blockList:[],
    //   errorList: '',
      model:{
        sewaPajak:{
            blockid:'',
            remark:'',
            dateInv: new Date().toISOString().slice(0,10),
            amount:'0',
            paymenttype:0,
            bank:null,
            bankacc:null,
            dateto: this.endDayMonth(),
            datefrom: new Date(this.firstDayMonth()).toISOString().slice(0,10),
        },
      }
    }
  },
  mounted(){
    this.listAllBlock();
  },
  methods: {
    listAllBlock(){
        this.blockList = [];
        axios.get('block/getBlockidList')
            .then(res => {
            // console.log(res.data.blockidList,"Success");
            res.data.blockidList.forEach(element => {
                var blockObj = {
                    "text": element.blockid, "value":element.blockname
                }
                this.blockList.push(blockObj);
                
              });
            }).catch(function (error){
                
              console.log('Error',error.message);
            });
            console.log(this.blockList,"Block List");
    },
    firstDayMonth() {
      const firstDayMonth = new Date();
      const date = `${firstDayMonth.getMonth()+1}/02/${firstDayMonth.getFullYear()}`;
      return date;
    },
    endDayMonth() {
        const now = new Date();
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        const tzOffset = lastDay.getTimezoneOffset() * 60000; // in ms
        const localISO = new Date(lastDay - tzOffset).toISOString().slice(0, 10);
        return localISO;
    },
    onChangePaymentType(){
        if(this.model.sewaPajak.paymentType == 0){
            this.model.sewaPajak.bank = null;
            this.model.sewaPajak.bankacc = null;
            return null;
        }
        if(this.model.sewaPajak.blockid == '') return null;
        axios.get('block/getBlockDetailByID/'+this.model.sewaPajak.blockid)
            .then(res => {
                this.model.sewaPajak.bank = res.data.block[0].bank;
                this.model.sewaPajak.bankacc = res.data.block[0].bankacc;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Block id, Date, and Amount is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    },
    addSewaPajak(){
        // var mythis = this;
        // console.log(this.model.sewaPajak);
        axios.post('block/addSewaPajak',this.model.sewaPajak)
            .then(res => {
                alert(res.data.message);
                this.model.sewaPajak = {
                    blockid:'',
                    remark:'',
                    dateInv: new Date().toISOString().slice(0,10),
                    amount:'',
                    paymenttype:0,
                    bank:null,
                    bankacc:null,
                    dateto: this.endDayMonth(),
                    datefrom: new Date(this.firstDayMonth()).toISOString().slice(0,10),
                };
                this.componentKey += 1;
            }).catch(function (error){
                if(error.response){
                    if(error.response.status == 422){
                        alert('Error: Block id, Date, and Amount is required! ');
                    }
                }else if(error.request){
                    console.log(error.request);
                }else{
                    console.log('Error',error.message);
                }
            });
    }
    
  },
}
</script>